import { render, staticRenderFns } from "./SendSeedsDialog.vue?vue&type=template&id=39e2b5de&scoped=true"
import script from "./SendSeedsDialog.vue?vue&type=script&lang=js"
export * from "./SendSeedsDialog.vue?vue&type=script&lang=js"
import style0 from "./SendSeedsDialog.vue?vue&type=style&index=0&id=39e2b5de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2b5de",
  null
  
)

export default component.exports